import { render } from "./ColoredMarquee.vue?vue&type=template&id=3b2e709e&scoped=true"
const script = {}

import "./ColoredMarquee.vue?vue&type=style&index=0&id=3b2e709e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2e709e"]])

export default __exports__